import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/event.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import learning from '../img/lea.gif';
import case_study from '../img/cs.gif';
import cme from '../img/cme.png';

import Footer from './footer';
import Com_Logo from './company_icon';

const Event = () => {

  
  const [selected_event, setSelected_event] = useState('');
  // const [dr_id, setDr_id] = useState('');
  const navigate = useNavigate();

  const handleSelect = (type) => {
    setSelected_event(type);
  };

  const handleSubmit = async (e) => {

      if (!selected_event) {
    toast.error("Please select an event");
    return;
  }

  sessionStorage.setItem('event',selected_event);

  const check_event = sessionStorage.getItem('event');
  // console.log("e1",check_event)

    
  if(check_event === 'learning'){
    navigate('/lea_event');
  }else if(check_event == 'case study'){
    navigate('/case_event');
  }else{
    navigate('/event'); //aj page uper
  }
  };

  return (
    <>

      <Com_Logo />
      <div className="home-container_event">
        <form className="login" onSubmit={handleSubmit}>
         
          <div className="home-title-wrapper">
          <h1 className="home-title">Select Your Event</h1>
          </div>

          <div className="card-container_event">
          <div
            className={`card_event ${selected_event === 'learning' ? 'selected_event' : ''}`}
            onClick={() => handleSelect('learning')}
            src={learning}
          >
            <img src={learning} alt="Learning" className="lea_img" />
            
          </div>

          <div
            className={`card_event ${selected_event === 'case study' ? 'selected_event' : ''}`}
            onClick={() => handleSelect('case study')}
          >
            <img src={case_study} alt="Case Study" className="case_img" />
          
          </div>

           <div
            className={`card_event ${selected_event === 'cme' ? 'selected_event' : ''}`}
            onClick={() => handleSelect('cme')}
          >
            <img src={cme} alt="CME" className="cme_img" />
          
          </div>

          </div>

          
            <button className="next-button_event " type="submit">
              Next
            </button>
       
        </form>

        <ToastContainer />
      </div>

      <Footer />
    </>
  );
};

export default Event;
